import React, { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import GUI from "../GUI"
import Overlay, { IOverlay } from "./Overlay"
import { IBackdrop, TBackdropProps } from "./Backdrop"

export type TAnchorPosition = "auto"|"below"|"above"|"left"|"right"
export type TAnchorWidth = "auto"|"match"|"min-match"
export type TAnchorProps = {
    follow?:string
    width?:TAnchorWidth
    anchorPosition?:TAnchorPosition
}

export type TAnchoredBackdropProps = TBackdropProps & {
}

function findAnchorTarget(selector:string|undefined){
    return selector ? document.querySelector(selector) || document.querySelector(`[follow-id=${selector}]`) : null
}

var g_anchorId = 0
export default forwardRef( (props:TAnchoredBackdropProps, ref?:ForwardedRef<IBackdrop>) => {
    const {overlayProps} = props
    const anchorProps = overlayProps.anchor!
    const [anchorPosition,setAnchorPosition] = useState<string>(anchorProps.anchorPosition || "below")
    const refSelf = useRef<IOverlay|null>(null)
    const refTimeout = useRef<any>()

    const target = findAnchorTarget(anchorProps.follow)

    const onDown = (e:PointerEvent) => {
        const element = document.elementFromPoint(e.clientX, e.clientY)
        if (refSelf.current?.target?.contains(element)) return true
        else if (!overlayProps.canDismiss || overlayProps.canDismiss?.(e)) props.onDismiss?.(props.overlayId)
        return true
    }

    useImperativeHandle(ref, () => ({onDown}))

    const onDismissed = () => props.onDismissed?.(props.overlayId)
    const anchor = () => {
        const self = refSelf.current?.target
        if (!target) console.log("target not found")
        if (!props.active || !self || !target) return

        const rSelf = self.getBoundingClientRect(), rTarget = target.getBoundingClientRect()

        switch(anchorProps.width) {
        case "match":
            if (rSelf.width!=rTarget.width) self.style.setProperty("width", rTarget.width+"px")
            break;
        case "min-match":
            if (rSelf.width<rTarget.width) self.style.setProperty("min-width", rTarget.width+"px")
            break;
        }

        var anchor = (rTarget.bottom + rSelf.height > window.innerHeight && rTarget.top - rSelf.height>0) ? "above" : "below"

        if (rTarget.left+rSelf.width+100>=window.innerWidth) {
            self.style.removeProperty("left")
            self.style.setProperty("right", "anchor(right)")//rTarget.right+"px")
            anchor += " right"
        }
        else {
            self.style.removeProperty("right")
            self.style.setProperty("left", "anchor(left)")//rTarget.left+"px")
            anchor += " left"
        }

        setAnchorPosition(anchor)    
        watch()
    }
    const watch = () => refTimeout.current = requestAnimationFrame(anchor)
    const unwatch = () => refTimeout.current && cancelAnimationFrame(refTimeout.current)
    useEffect(() => {
        if (refSelf.current && target) {
            if (!GUI.isHTMLElement(target)) return console.warn("Anchor follow not found", anchorProps.follow)
            let anchorName = target.style.getPropertyValue("anchor-name")
            if (!anchorName) {
                anchorName = target.id ? `--${target.id}` : `--overlay_${g_anchorId++}`
                target.style.setProperty("anchor-name", anchorName)
            }
            const positionAnchor = refSelf.current.target?.style.getPropertyValue("position-anchor")
            if (positionAnchor!=anchorName) refSelf.current.target?.style.setProperty("position-anchor", anchorName)
            watch()
        }
        return () => { unwatch()}
    }, [target])

    const id = props.id ? {id:props.id} : {}
    return <Overlay overlay-id={props.overlayId} className={GUI.joinClass(anchorProps.follow ? "anchor" : "", anchorPosition, props.overlayProps.backdropClass)} {...id} {...overlayProps} open={props.active} afterLeaving={onDismissed} ref={refSelf}/>
})